class RelatedProducts extends HTMLElement {
  variantIdChangedUnsubscriber  = undefined; 
  connectedCallback() {
      
    this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    this.reloadSection(event);
    });
  }

  disconnectedCallback() {
    if (this.variantIdChangedUnsubscriber) {
       this.variantIdChangedUnsubscriber();
    }
  }
  reloadSection(event) {
    this.variantId = event.data.variant.id.toString();
    
    fetch(`${window.location.pathname}?section_id=${this.id}&variant=${this.variantId}`)
      .then(response => response.text())
      .then(html => {
        const newContent = new DOMParser().parseFromString(html, "text/html").getElementById(`${this.id}`);
        if (newContent) {
          this.innerHTML = newContent.innerHTML;
          requestAnimationFrame(() => {
          loadExternalScript();  
        });
        }
      })
      .catch(error => console.error("Fehler beim Neuladen der Section:", error));    
  }
}

customElements.define("related-products", RelatedProducts);

function loadExternalScript() {
    initProductSlider();
}

